
function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }
function getContrastColor(color) {
    // http://www.w3.org/TR/AERT#color-contrast
    const brightness = Math.round((
        parseInt(color.r) * 299 +
        parseInt(color.g) * 587 +
        parseInt(color.b) * 114) / 1000);
    return (brightness > 125) ? 'black' : 'white';
}

export {
    componentToHex,
    hexToRgb,
    getContrastColor
}
